// @flow
import React, {Fragment, PureComponent} from 'react';
import {
  Dimensions,
  Image,
  ImageBackground,
  StyleSheet,
  View,
} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import {Carousel} from './components';

class Onboarding extends PureComponent<Props> {
  styles = getStyles();

  renderContent = (imageSource: number, index: number) => {
    const styles = this.styles;
    return (
      <Fragment>
        {!theme.onboarding.fullscreenImages && (
          <View style={styles.imageContainer}>
            <Image
              source={imageSource}
              resizeMode="contain"
              style={styles.image}
            />
          </View>
        )}
        <View
          style={[
            styles.captionContainer,
            theme.onboarding.fullscreenImages &&
              styles.fullscreenImagesCaptionContainer,
          ]}>
          <Text style={styles.title}>
            {I18n.t(`Onboarding.screens.${index}.title`)}
          </Text>
          <Text style={styles.description}>
            {I18n.t(`Onboarding.screens.${index}.subtitle`)}
          </Text>
        </View>
      </Fragment>
    );
  };
  render() {
    const styles = this.styles;
    return (
      <Carousel
        style={styles.carousel}
        onSkip={this.props.resetToWelcomeScreen}
        labelDone={I18n.t('Onboarding.doneLabel')}
        skipLabel={I18n.t('skip')}
        testID={'onboardingCarousel'}>
        {theme.onboardingImages.map((imageSource, index) =>
          theme.onboarding.fullscreenImages ? (
            <ImageBackground
              style={[styles.page, styles.fullscreenImagesPage]}
              source={imageSource}
              key={index}>
              {this.renderContent(imageSource, index)}
            </ImageBackground>
          ) : (
            <View style={styles.page} key={index}>
              {this.renderContent(imageSource, index)}
            </View>
          ),
        )}
      </Carousel>
    );
  }
}

type Props = DispatchProps;

export type DispatchProps = {
  resetToWelcomeScreen: Function,
};

const getStyles = () =>
  StyleSheet.create({
    carousel: {
      flex: 1,
      marginTop: 25,
    },
    page: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'white',
    },
    fullscreenImagesPage: {
      justifyContent: 'flex-end',
    },
    imageContainer: {
      marginBottom: 60,
    },
    image: {
      height: Dimensions.get('window').height * 0.4,
    },
    captionContainer: {
      paddingHorizontal: '10%',
      marginBottom: 50,
    },
    fullscreenImagesCaptionContainer: {
      marginBottom: 150,
    },
    title: {
      textAlign: 'center',
      backgroundColor: 'transparent',
      color: theme.onboarding.textColor,
      fontSize: 20,
      fontWeight: '500',
      marginBottom: 10,
    },
    description: {
      textAlign: 'center',
      backgroundColor: 'transparent',
      color: theme.onboarding.textColor,
      fontSize: 14,
    },
  });

export default Onboarding;
